<template>
  <Layout>
    <template #sidebar="{ topbarNavigation }">
      <Sidenav :topbar-navigation="topbarNavigation" :navigation="navigation" />
    </template>

    <template #contextual-nav>
      <div class="sticky top-0 z-contextual-nav mb-contextual-nav-mb bg-white">
        <ContextualNav
          v-if="tabs.length > 0"
          class="mx-auto max-w-content-container"
          :tabs="tabs"
        />
      </div>
    </template>

    <slot />
  </Layout>
</template>

<script setup lang="ts">
import Layout from '~/components/Layout.vue'
import ContextualNav from '~/components/layout/ContextualNav.vue'
import Sidenav from '~/components/layout/Sidenav.vue'
import { useNavigationStore } from '~/stores/navigation'

const navigationStore = useNavigationStore()
const { navigation, tabs } = storeToRefs(navigationStore)
</script>
